import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=fb4ef774&scoped=true"
import script from "./notice.vue?vue&type=script&lang=ts"
export * from "./notice.vue?vue&type=script&lang=ts"
import style0 from "./notice.vue?vue&type=style&index=0&id=fb4ef774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4ef774",
  null
  
)

export default component.exports